var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_36",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_36)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20H0V0ZM8.75 2.91667C8.75 2.58515 8.8817 2.2672 9.11612 2.03278C9.35054 1.79836 9.66848 1.66667 10 1.66667C10.3315 1.66667 10.6495 1.79836 10.8839 2.03278C11.1183 2.2672 11.25 2.58515 11.25 2.91667V12.9167C11.25 13.2482 11.1183 13.5661 10.8839 13.8005C10.6495 14.035 10.3315 14.1667 10 14.1667C9.66848 14.1667 9.35054 14.035 9.11612 13.8005C8.8817 13.5661 8.75 13.2482 8.75 12.9167V2.91667ZM10 15.8333C9.66848 15.8333 9.35054 15.965 9.11612 16.1995C8.8817 16.4339 8.75 16.7518 8.75 17.0833C8.75 17.4149 8.8817 17.7328 9.11612 17.9672C9.35054 18.2016 9.66848 18.3333 10 18.3333C10.3315 18.3333 10.6495 18.2016 10.8839 17.9672C11.1183 17.7328 11.25 17.4149 11.25 17.0833C11.25 16.7518 11.1183 16.4339 10.8839 16.1995C10.6495 15.965 10.3315 15.8333 10 15.8333Z",
    fill: "#6B6F76"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyExclamation);
export default __webpack_public_path__ + "static/media/grey_exclamation.2f3ee47db029b6d91c105d22fff511cf.svg";
export { ForwardRef as ReactComponent };